class StickyHeader extends HTMLElement {
	constructor() {
		super();
		this.lastScrollY = window.scrollY;
	}

	connectedCallback() {
		this.announcementBar = document.querySelector(".announcement-bar");
		this.setAnnouncementBarHeight(this.getVisibleAnnouncementBarHeight());
		window.addEventListener("scroll", this.handleScroll.bind(this));
	}

	// La barre d'annonce n'est pas réellement sticky : une fois scrollée elle
	// n'est plus visible, sa hauteur effective est alors 0.
	getVisibleAnnouncementBarHeight() {
		if (!this.announcementBar) return 0;
		return Math.max(
			0,
			Math.round(this.announcementBar.getBoundingClientRect().bottom),
		);
	}

	setAnnouncementBarHeight(height) {
		document.documentElement.style.setProperty(
			"--announcement-bar-height",
			`${height}px`,
		);
	}

	handleScroll() {
		const currentScrollY = window.scrollY;

		if (currentScrollY <= 0) {
			document.documentElement.classList.remove("scroll-up", "scroll-down");
			this.setAnnouncementBarHeight(this.getVisibleAnnouncementBarHeight());
		} else if (currentScrollY < this.lastScrollY) {
			// Scroll up
			this.reveal();
		} else {
			// Scroll down
			this.hide();
		}

		this.lastScrollY = currentScrollY;
	}

	reveal() {
		this.setAnnouncementBarHeight(this.getVisibleAnnouncementBarHeight());
		document.documentElement.classList.add("scroll-up");
		document.documentElement.classList.remove("scroll-down");
	}

	hide() {
		this.setAnnouncementBarHeight(0);
		document.documentElement.classList.add("scroll-down");
		document.documentElement.classList.remove("scroll-up");
	}

	disconnectedCallback() {
		window.removeEventListener("scroll", this.handleScroll.bind(this));
	}
}

customElements.define("sticky-header", StickyHeader);
